import { Typography } from '@web-chat-core/ui-kit';
import type { MenuItem } from '../ControlButtonMenu/ControlButtonMenu';
import { ItemWrapper } from './view';
import { LabelRow } from './LabelRow';

interface ControlButtonMenuItemProps {
    item: MenuItem;
    onSelect: (item: MenuItem) => void;
}

export const ControlButtonMenuItem = ({ item, onSelect }: ControlButtonMenuItemProps) => {
    switch (item.type) {
        case 'title':
            return (
                <ItemWrapper $fullWidth={item.fullWidth}>
                    <Typography variant="body3" colorVariant="second">
                        {item.text}
                    </Typography>
                </ItemWrapper>
            );

        case 'element': {
            const Element = item.element as React.ComponentType;
            return (
                <ItemWrapper $fullWidth={item.fullWidth}>
                    <Element />
                </ItemWrapper>
            );
        }

        case 'menu': {
            const Element = item.element as React.ComponentType;
            return <Element />;
        }

        case 'label':
            return <LabelRow item={item} onSelect={onSelect} />;

        default:
            return null;
    }
};

ControlButtonMenuItem.displayName = 'ControlButtonMenuItem';
